<script lang="ts" setup>
import { computed, ref } from 'vue'

import MedicalActForm from '@/stay-displayer/medical-act/MedicalActForm.vue'
import MedicalAct from '@/stay-displayer/smr/rhs/medical-act/MedicalAct.vue'
import { CodedMedicalAct } from '@/store/modules/medical-act/types'
import { PmsiTypeEnum } from '@/store/modules/settings/types'
import { Rhs, RhsDashboardButtonLabel, RhsDashboardTitle, RhsDashboardType } from '@/store/modules/stay/smr/types'

const props = defineProps<{
  codedActs: CodedMedicalAct[]
  rhs: Rhs
}>()

const actFormVisible = ref(false)
const displayedCodedActs = computed(() => props.codedActs.filter((codedAct) => !codedAct.disabled))
</script>

<template>
  <div class="dashboard-title d-flex justify-content-between">
    <small>{{ RhsDashboardTitle[RhsDashboardType.RHS_DASHBOARD_ACT_CCAM] }}</small>
    <small>{{ $t('stayDisplayer.smr.rhs.codingInProgress') }}</small>
  </div>
  <div v-if="codedActs.length === 0">
    <small class="aligned-row fst-italic">Aucun acte</small>
  </div>
  <medical-act
    v-for="codedAct in displayedCodedActs"
    v-else
    :key="codedAct.id"
    :coded-act="codedAct"
    :rhs-id="rhs.id"
  />
  <div class="aligned-row mt-2">
    <button
      id="add-medical-act-button"
      type="button"
      class="col-12 btn btn-sm"
      @click="actFormVisible = true"
    >
      {{ RhsDashboardButtonLabel[RhsDashboardType.RHS_DASHBOARD_ACT_CCAM] }}
    </button>
  </div>
  <medical-act-form
    :summary-unit="rhs"
    :pmsi-type="PmsiTypeEnum.SMR"
    :presence-days="rhs.weekDays+rhs.weekEndDays"
    :visible="actFormVisible"
    @close-form="actFormVisible = false"
  />
</template>
